// Package Management APIs
/**
 * @function ApiClient#GetPackageList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} filters
 * @param {any} options = {}
 */
export async function GetPackageList(cid, filters, options = {}) {
  const {
    sortBy,
    sortDesc,
    page,
    itemsPerPage,
    status,
    startDate = "",
    endDate = "",
    startDate_check = "",
    endDate_check = "",
    packageType = "",
    building = "",
    doorPlate = "",
    floor = "",
    checkMethod = "",
    barcode = "",
    packageTypeCustomName = "",
    packageCash = "",
  } = filters;

  const url = `/community/${cid}/package_list?s=${status}&p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&st=${startDate}&et=${endDate}&stc=${startDate_check}&etc=${endDate_check}&pt=${packageType}&b=${building}&d=${doorPlate}&f=${floor}&cm=${checkMethod}&bc=${barcode}&ptcn=${packageTypeCustomName}&pc=${packageCash}`;

  return await this._get(url, options);
}

/**
 * @function ApiClient#GetPackageListWaitReceiveByDeviceDBID
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} deviceID
 * @param {any} options = {}
 */
export async function GetPackageListWaitReceiveByDeviceDBID(cid, deviceID, options = {}) {
  return await this._get(`/community/${cid}/package_list?s=2&did=${deviceID}`, options);
}

/**
 * @function ApiClient#GetPackageListWaitReceiveByCardUID
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} cardUID
 * @param {any} options = {}
 */
export async function GetPackageListWaitReceiveByCardUID(cid, cardUID, options = {}) {
  return await this._get(`/community/${cid}/package_list?s=2&c=${cardUID}`, options);
}

/**
 * @function ApiClient#GetPackageListWaitReceiveByHouseHold
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} options = {}
 */
export async function GetPackageListWaitReceiveByHouseHold(cid, { building, doorPlate, floor }, options = {}) {
  return await this._get(`/community/${cid}/package_list?s=2&b=${building}&d=${doorPlate}&f=${floor}`, options);
}

/**
 * @function ApiClient#UpdatePackage
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.User
 * @param {any} params.Package
 * @param {any} params.Status
 * @param {any} params.CheckMethod
 * @param {any} params.DeviceDBID
 * @param {any} params.CardUID
 * @param {any} params.CheckPS
 * @param {any} params.Image
 * @param {any} options = {}
 */
export async function UpdatePackage(cid, { User, Package, Status, CheckMethod, DeviceDBID, CardUID, CheckPS, Image }, options = {}) {
  const formData = new FormData();
  if (User) formData.set("User", User);
  formData.set("Package", Package);
  formData.set("Status", Status);
  formData.set("CheckMethod", CheckMethod);
  if (DeviceDBID) formData.set("DeviceDBID", DeviceDBID);
  if (CardUID) formData.set("CardUID", CardUID);
  if (CheckPS) formData.set("CheckPS", CheckPS);
  if (Image) formData.set("Image", Image, "webcam.jpg");

  return await this._put(`/community/${cid}/package`, formData, options);
}

/**
 * @function ApiClient#PackageNotifyAgain
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} packageList
 * @param {any} options = {}
 */
export async function PackageNotifyAgain(cid, packageList, options = {}) {
  return await this._post(`/community/${cid}/package_notify_again?p=${packageList.join(",")}`, null, options);
}

/**
 * @function ApiClient#PackageCancelRegistration
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} packageList
 * @param {any} options = {}
 */
export async function PackageCancelRegistration(cid, packageList, options = {}) {
  return await this._put(`/community/${cid}/batch_package_to_wait_return`, { PackageIds: packageList.join(",") }, options);
}

/**
 * @function ApiClient#PackageCloseOrder
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} packageList
 * @param {any} options = {}
 */
export async function PackageCloseOrder(cid, packageList, options = {}) {
  return await this._put(`/community/${cid}/batch_package_to_return`, { PackageIds: packageList.join(",") }, options);
}

// Package Place Management APIs
/**
 * @function ApiClient#GetPackagePlaceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetPackagePlaceList(cid, options = {}) {
  return await this._get(`/community/${cid}/package_place_list`, options);
}

/**
 * @function ApiClient#AddPackagePlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} placeName
 * @param {any} options = {}
 */
export async function AddPackagePlace(cid, placeName, options = {}) {
  return await this._post(`/community/${cid}/package_place?p=${placeName}`, null, options);
}

/**
 * @function ApiClient#UpdatePackagePlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} places
 * @param {any} options = {}
 */
export async function UpdatePackagePlace(cid, places, options = {}) {
  return await this._put(`/community/${cid}/package_place`, places, options);
}

/**
 * @function ApiClient#DeletePackagePlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} placeName
 * @param {any} options = {}
 */
export async function DeletePackagePlace(cid, placeName, options = {}) {
  return await this._delete(`/community/${cid}/package_place?p=${placeName}`, options);
}

// Deposit Package APIs
/**
 * @function ApiClient#GetPackageListDepositWaitReceiveByDeviceDBID
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} deviceID
 * @param {any} options = {}
 */
export async function GetPackageListDepositWaitReceiveByDeviceDBID(cid, deviceID, options = {}) {
  return await this._get(`/community/${cid}/package_list?s=6&did=${deviceID}`, options);
}

/**
 * @function ApiClient#GetPackageListDepositWaitReceiveByCardUID
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} cardUID
 * @param {any} options = {}
 */
export async function GetPackageListDepositWaitReceiveByCardUID(cid, cardUID, options = {}) {
  return await this._get(`/community/${cid}/package_list?s=6&c=${cardUID}`, options);
}

/**
 * @function ApiClient#GetPackageListDepositWaitReceiveByHouseHold
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} options = {}
 */
export async function GetPackageListDepositWaitReceiveByHouseHold(cid, { building, doorPlate, floor }, options = {}) {
  return await this._get(`/community/${cid}/package_list?s=6&b=${building}&d=${doorPlate}&f=${floor}`, options);
}

// Package Type Management APIs

/**
 * @function ApiClient#GetPackageTypeList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} page = 1
 * @param {any} perPage = 100
 * @param {any} sortBy = "Sort"
 * @param {any} sortOrder = 1
 * @param {any} options = {}
 */
export async function GetPackageTypeList(cid, page = 1, perPage = 100, sortBy = "Sort", sortOrder = 1, options = {}) {
  return await this._get(`/community/${cid}/package_type_list?p=${page}&pp=${perPage}&sb=${sortBy}&so=${sortOrder}`, options);
}

/**
 * @function ApiClient#GetPackageType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetPackageType(cid, id, options = {}) {
  return await this._get(`/community/${cid}/package_type/${id}`, options);
}

/**
 * @function ApiClient#AddPackageType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddPackageType(cid, data, options = {}) {
  return await this._post(`/community/${cid}/package_type`, data, options);
}

/**
 * @function ApiClient#UpdatePackageType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdatePackageType(cid, id, data, options = {}) {
  return await this._put(`/community/${cid}/package_type/${id}`, data, options);
}

/**
 * @function ApiClient#DeletePackageType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function DeletePackageType(cid, id, options = {}) {
  return await this._delete(`/community/${cid}/package_type/${id}`, options);
}

// Shipping From Management APIs

/**
 * @function ApiClient#GetShippingFromList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} page = 1
 * @param {any} perPage = 100
 * @param {any} sortBy = "Sort"
 * @param {any} sortOrder = 1
 * @param {any} options = {}
 */
export async function GetShippingFromList(cid, page = 1, perPage = 100, sortBy = "Sort", sortOrder = 1, options = {}) {
  return await this._get(`/community/${cid}/shipping_from_list?p=${page}&pp=${perPage}&sb=${sortBy}&so=${sortOrder}`, options);
}

/**
 * @function ApiClient#GetShippingFrom
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetShippingFrom(cid, id, options = {}) {
  return await this._get(`/community/${cid}/shipping_from/${id}`, options);
}

/**
 * @function ApiClient#AddShippingFrom
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddShippingFrom(cid, data, options = {}) {
  return await this._post(`/community/${cid}/shipping_from`, data, options);
}

/**
 * @function ApiClient#UpdateShippingFrom
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateShippingFrom(cid, id, data, options = {}) {
  return await this._put(`/community/${cid}/shipping_from/${id}`, data, options);
}

/**
 * @function ApiClient#DeleteShippingFrom
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function DeleteShippingFrom(cid, id, options = {}) {
  return await this._delete(`/community/${cid}/shipping_from/${id}`, options);
}

// Shipping Provider Management APIs

/**
 * @function ApiClient#GetShippingProviderList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} page = 1
 * @param {any} perPage = 100
 * @param {any} sortBy = "Sort"
 * @param {any} sortOrder = 1
 * @param {any} options = {}
 */
export async function GetShippingProviderList(cid, page = 1, perPage = 100, sortBy = "Sort", sortOrder = 1, options = {}) {
  return await this._get(`/community/${cid}/shipping_provider_list?p=${page}&pp=${perPage}&sb=${sortBy}&so=${sortOrder}`, options);
}

/**
 * @function ApiClient#GetShippingProvider
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetShippingProvider(cid, id, options = {}) {
  return await this._get(`/community/${cid}/shipping_provider/${id}`, options);
}

/**
 * @function ApiClient#AddShippingProvider
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddShippingProvider(cid, data, options = {}) {
  return await this._post(`/community/${cid}/shipping_provider`, data, options);
}

/**
 * @function ApiClient#UpdateShippingProvider
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateShippingProvider(cid, id, data, options = {}) {
  return await this._put(`/community/${cid}/shipping_provider/${id}`, data, options);
}

/**
 * @function ApiClient#DeleteShippingProvider
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function DeleteShippingProvider(cid, id, options = {}) {
  return await this._delete(`/community/${cid}/shipping_provider/${id}`, options);
}

// Facility Type Management APIs

/**
 * @function ApiClient#GetFacilityTypeList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} page = 1
 * @param {any} perPage = 100
 * @param {any} sortBy = "Sort"
 * @param {any} sortOrder = 1
 * @param {any} options = {}
 */
export async function GetFacilityTypeList(cid, page = 1, perPage = 100, sortBy = "Sort", sortOrder = 1, options = {}) {
  return await this._get(`/community/${cid}/facility_type_list?p=${page}&pp=${perPage}&sb=${sortBy}&so=${sortOrder}`, options);
}

/**
 * @function ApiClient#GetFacilityType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetFacilityType(cid, id, options = {}) {
  return await this._get(`/community/${cid}/facility_type/${id}`, options);
}

/**
 * @function ApiClient#AddFacilityType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddFacilityType(cid, data, options = {}) {
  return await this._post(`/community/${cid}/facility_type`, data, options);
}

/**
 * @function ApiClient#UpdateFacilityType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateFacilityType(cid, id, data, options = {}) {
  return await this._put(`/community/${cid}/facility_type/${id}`, data, options);
}

/**
 * @function ApiClient#DeleteFacilityType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function DeleteFacilityType(cid, id, options = {}) {
  return await this._delete(`/community/${cid}/facility_type/${id}`, options);
}

// Visit Reason Company Management APIs

/**
 * @function ApiClient#GetVisitReasonCompanyList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} page = 1
 * @param {any} perPage = 100
 * @param {any} sortBy = "Name"
 * @param {any} sortOrder = 1
 * @param {any} options = {}
 */
export async function GetVisitReasonCompanyList(cid, page = 1, perPage = 100, sortBy = "Name", sortOrder = 1, options = {}) {
  return await this._get(`/community/${cid}/visit_reason_company_list?p=${page}&pp=${perPage}&sb=${sortBy}&so=${sortOrder}`, options);
}

/**
 * @function ApiClient#GetVisitReasonCompanyAll
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetVisitReasonCompanyAll(cid, options = {}) {
  return await this._get(`/community/${cid}/visit_reason_company_all`, options);
}

/**
 * @function ApiClient#GetVisitReasonCompany
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetVisitReasonCompany(cid, id, options = {}) {
  return await this._get(`/community/${cid}/visit_reason_company/${id}`, options);
}

/**
 * @function ApiClient#AddVisitReasonCompany
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddVisitReasonCompany(cid, data, options = {}) {
  return await this._post(`/community/${cid}/visit_reason_company`, data, options);
}

/**
 * @function ApiClient#UpdateVisitReasonCompany
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateVisitReasonCompany(cid, id, data, options = {}) {
  return await this._put(`/community/${cid}/visit_reason_company/${id}`, data, options);
}

/**
 * @function ApiClient#DeleteVisitReasonCompany
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function DeleteVisitReasonCompany(cid, id, options = {}) {
  return await this._delete(`/community/${cid}/visit_reason_company/${id}`, options);
}

// Visit Reason Management APIs

/**
 * @function ApiClient#GetVisitReasonList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} page = 1
 * @param {any} perPage = 100
 * @param {any} sortBy = "Sort"
 * @param {any} sortOrder = 1
 * @param {any} options = {}
 */
export async function GetVisitReasonList(cid, page = 1, perPage = 100, sortBy = "Sort", sortOrder = 1, options = {}) {
  return await this._get(`/community/${cid}/visit_reason_list?p=${page}&pp=${perPage}&sb=${sortBy}&so=${sortOrder}`, options);
}

/**
 * @function ApiClient#GetVisitReason
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetVisitReason(cid, id, options = {}) {
  return await this._get(`/community/${cid}/visit_reason/${id}`, options);
}

/**
 * @function ApiClient#AddVisitReason
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddVisitReason(cid, data, options = {}) {
  return await this._post(`/community/${cid}/visit_reason`, data, options);
}

/**
 * @function ApiClient#UpdateVisitReason
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateVisitReason(cid, id, data, options = {}) {
  return await this._put(`/community/${cid}/visit_reason/${id}`, data, options);
}

/**
 * @function ApiClient#DeleteVisitReason
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function DeleteVisitReason(cid, id, options = {}) {
  return await this._delete(`/community/${cid}/visit_reason/${id}`, options);
}
